import { ApiTarget } from '../environment/api-environment.model';
import { API_ROUTE_OVERRIDES } from './api-route-overrides';
import { API_ROUTE_PREFIXES } from './api-route-prefixes';

export function resolveApiTarget(normalizedPath: string): ApiTarget | null {
  const path = normalizedPath.replace(/^\/+/, '');

  for (const override of API_ROUTE_OVERRIDES) {
    if (path === override.path || path.startsWith(`${override.path}/`)) {
      return override.target;
    }
  }

  for (const rule of API_ROUTE_PREFIXES) {
    if (path === rule.prefix || path.startsWith(rule.prefix)) {
      return rule.target;
    }
  }

  return null;
}
